import React, { useState } from "react";
import { Col, Row, Modal, Button, Spinner } from "react-bootstrap";
import mobile from "../../Images/mobile.png";
import deleteicon from "../../Images/delete.png";
import DeleteCartHook from "../../hook/cart/DeleteCartHook";
import CartAttachmentHook from "../../hook/cart/CartAttachmentHook";
import ViewAllUsersHook from "../../hook/admin/ViewAllUsersHook";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import calculatePriceForProductItem from "../../helpers/calculatePriceForProductItem";
const CartItem = ({ item }) => {
  // console.log(item);
  // console.log('-------------------------');
  const { t } = useTranslation();

  const [
    handleDeletCart,
    show,
    handleClose,
    handleShow,
    handleDeleteItem,
    itemCount,
    onChangeCount,
    handleUpdateCart,
    itemNotes,
    onChangeItemNotes,
  ] = DeleteCartHook(item);

  const [
    showAttachmentModal,
    handleShowAttachmentModal,
    handleCloseAttachmentModal,
    attachmentImage,
    handleAttachmentImageChange,
    handleAttachmentSubmit,
    loadingAttachment,
  ] = CartAttachmentHook(item);
  const settingsRes = useSelector((state) => state.settingsReducers.settings);

  const [users, clickHandler, webSiteData, handleShowFun, showReviews] =
    ViewAllUsersHook();

  // let priceOffer=0;
  // if(item?.product?.Offer!=null)
  // priceOffer=calculatePriceForProductItem(item.product);

  //(item && (item?.product?.Offer * item?.quantity).toFixed(2))

  var user = null;
  if (localStorage.getItem("user") != null) {
    user = JSON.parse(localStorage.getItem("user"));
  }

  return (
    <div className="cart-item-card">
      {/* confirm delete modal */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>
            <div className="font"> {t("confirm delete")} </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="font">
            {t("Are you sure to remove the product from the cart")}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="font" variant="secondary" onClick={handleClose}>
            {t("retreat")}
          </Button>
          <Button className="font" variant="danger" onClick={handleDeleteItem}>
            {t("delete")}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* attachment upload modal */}
      <Modal show={showAttachmentModal} onHide={handleCloseAttachmentModal}>
        <Modal.Header>
          <Modal.Title>
            <div className="font"> {t("upload attachment")} </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label htmlFor="cart_attachment_image">{t("select image")}</label>
          <input
            id="cart_attachment_image"
            type="file"
            accept="image/*"
            onChange={handleAttachmentImageChange}
            className="input-form d-block mt-2 px-3"
          />
          {attachmentImage && (
            <img
              src={URL.createObjectURL(attachmentImage)}
              alt="attachment"
              style={{ maxWidth: "200px", maxHeight: "200px" }}
              className="mt-2"
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="font"
            variant="secondary"
            onClick={handleCloseAttachmentModal}
          >
            {t("retreat")}
          </Button>
          <button
            className="btn-a font"
            style={{ backgroundColor: webSiteData?.PRIMARY_COLOR || "#3182ce", color: "white" }}
            onClick={handleAttachmentSubmit}
            disabled={loadingAttachment}
          >
            {loadingAttachment ? <Spinner animation="border" size="sm" /> : t("apply")}
          </button>
        </Modal.Footer>
      </Modal>

      {/* Delete button (top left corner) */}
      <button className="cart-delete-btn" onClick={handleShow} title={t("delete")}>
        <i className="fa-solid fa-trash-can"></i>
      </button>

      <Row className="align-items-center">
        {/* Product Image */}
        <Col xs="4" sm="3" md="3" lg="2" className="text-center">
          <img
            className="cart-item-img"
            src={(item && item?.product?.image) || mobile}
            alt={item?.product?.nameAr || "product"}
          />
        </Col>

        {/* Product Details */}
        <Col xs="8" sm="9" md="5" lg="6">
          <a href={`/product/${item?.product?._id}`} className="cart-item-title">
            {item && Cookies.get("i18next") === "ar"
              ? item?.product?.nameAr || " "
              : item?.product?.nameEn || " "}
          </a>
          
          <div className="d-flex align-items-center mb-2 gap-2 flex-wrap">
            <span className="text-muted" style={{ fontSize: "0.9rem" }}>
              {item && Cookies.get("i18next") === "ar"
                ? item?.product?.category?.nameAr || ""
                : item?.product?.category?.nameEn || ""}
            </span>
            
            {settingsRes?.data?.showBrand === true && item?.product?.brand && (
              <span className="cart-item-badge">
                {Cookies.get("i18next") === "ar"
                  ? item?.product?.brand?.nameAr || ""
                  : item?.product?.brand?.nameEn || ""}
              </span>
            )}
            
            {item?.variant && (
              <span className="cart-item-badge text-primary bg-primary bg-opacity-10">
                {item?.variant?.title?.includes("__::SEPARATOR::__")
                  ? Cookies.get("i18next") === "ar"
                    ? item?.variant?.title?.split("__::SEPARATOR::__")[1]
                    : item?.variant?.title?.split("__::SEPARATOR::__")[0]
                  : item?.variant?.title}
              </span>
            )}

            {item && item.color && (
              <div
                className="color border rounded-circle"
                style={{ backgroundColor: `${item.color}`, width: "20px", height: "20px" }}
              ></div>
            )}
          </div>

          <div className="d-flex flex-wrap align-items-center gap-2 mt-3">
             <div className="cart-qty-control me-3">
               <input
                 value={itemCount}
                 onChange={onChangeCount}
                 className="cart-qty-input"
                 type="number"
                 readOnly={user == null}
                 min="1"
               />
               <button
                 className="btn btn-sm btn-outline-primary ms-2"
                 onClick={handleUpdateCart}
                 style={{ padding: "2px 8px", fontSize: "0.8rem" }}
               >
                 {t("apply")}
               </button>
             </div>
             
             {user && (
               <button
                 className="btn btn-sm btn-light border text-muted"
                 onClick={handleShowAttachmentModal}
               >
                 <i className="fa-solid fa-paperclip me-1"></i>
                 {t("add attachment")}
               </button>
             )}
          </div>
          
          <div className="mt-2">
             <textarea
                id="richDescriptionAr"
                onChange={onChangeItemNotes}
                value={itemNotes}
                className="form-control form-control-sm text-muted bg-light"
                placeholder={t("add notes")}
                rows="1"
                onBlur={handleUpdateCart}
              />
          </div>
        </Col>

        {/* Product Price & Actions */}
        <Col xs="12" md="4" lg="4" className="d-flex flex-column justify-content-center align-items-md-end align-items-start mt-3 mt-md-0 border-start ps-md-4">
           <div className="text-muted small mb-1">{t("Total Price")}</div>
           <div className="cart-item-price">
              {
                item?.product?.Offer == null ? (
                  item?.variant?.price ? (
                    <>
                      {(item && (item?.variant?.price * item?.quantity).toFixed(2)) || ""}{" "}
                      {t("currency")}
                    </>
                  ) : (
                    <>
                      {(item && (item?.product?.price1 * item?.quantity).toFixed(2)) || ""}{" "}
                      {t("currency")}
                    </>
                  )
                ) : (
                  <>
                    {(item && item?.priceAfter * item?.quantity).toFixed(2) || ""}{" "}
                    {t("currency")}
                  </>
                )
              }
           </div>
           
           {showReviews ? (
              <div className="mt-2 text-warning fw-bold">
                <i className="fa-solid fa-star me-1"></i>
                {(item && item?.product?.ratingsAverage?.toFixed(2)) || 0}
              </div>
            ) : null}
        </Col>
      </Row>
    </div>
  );
};

export default CartItem;
